import { useEffect } from "react";
import EnterpriseOnly from "./components/EnterpriseOnly";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginOverlay from "./components/LoginOverlay";
import AdminPage from "./pages/AdminPage";
import BuffettPage from "./pages/BuffettPage";
import LabShell from "./components/lab/LabShell";
import ChatPage from "./pages/ChatPage";
import DcfPage from "./pages/DcfPage";
import MarketPage from "./pages/MarketPage";
import PeerPage from "./pages/PeerPage";
import ReportPage from "./pages/ReportPage";
import { REPORT_ENABLED } from "./lib/reportMeta";
import { GRAPH_CHAT_ENABLED } from "./lib/graphChat";
import { RCPS_ENABLED } from "./lib/rcps/enabled";
import { RELATIVE_ENABLED } from "./lib/relative";
import { RE_ENABLED } from "./lib/realEstate";
import { lazy, Suspense } from "react";

// 부동산 매매사례 — 초기 저장 데이터(300KB)와 지도 코드가 실려 있어 /re 에 들어올 때만 받는다
const RcpsPage = lazy(() => import("./pages/RcpsPage"));
const RelativePage = lazy(() => import("./pages/RelativePage"));
const RealEstatePage = lazy(() => import("./pages/RealEstatePage"));
// 부동산 검토보고서 새 탭 — 사이드바(LabShell) 밖의 독립 화면. 자료는 원 화면이 localStorage 로 건넨다
const RealEstateReportTab = lazy(() => import("./pages/RealEstateReportTab"));
import { useAuth } from "./stores/auth";

export default function App() {
  const { user, checking, checkAuth } = useAuth();

  useEffect(() => {
    void checkAuth();
  }, [checkAuth]);

  if (checking) return <div className="v2-boot">확인 중…</div>;

  // 바닐라와 동일한 로그인 게이트 — 뒤 페이지를 렌더한 채 반투명·블러
  // 오버레이를 덮는다 (미로그인 시 데이터 로드는 각 스토어가 user 로 게이트).
  return (
    <BrowserRouter>
      <Routes>
        {/* layout route — 첫 메시지에서 / → /c/:id 로 URL 이 바뀌어도 ChatPage 가
            리마운트되지 않는다. 별개 Route 두 개면 리마운트되면서 화면이 send 직후
            스냅샷으로 교체돼 첫 턴 진행 단계가 통째로 사라졌다 (LabShell 과 같은 패턴) */}
        <Route element={<ChatPage />}>
          <Route index element={null} />
          <Route path="/c/:conversationId" element={null} />
          {/* 문서함 전용 URL — 새로고침·공유·lab 페이지에서의 진입 모두 이 주소로 */}
          <Route path="/library" element={null} />
          {/* Graph DB 챗(QC 베타) — 같은 ChatPage 가 URL·대화ID 프리픽스로 dskg 모드 판정 */}
          {GRAPH_CHAT_ENABLED && <Route path="/graph-chat" element={null} />}
        </Route>
        <Route path="/dcf/*" element={<EnterpriseOnly feature="DCF 워크스페이스"><DcfPage /></EnterpriseOnly>} />
        {/* layout route — 버핏 ↔ 유사기업 전환 때 사이드바가 리마운트되지 않는다 */}
        <Route element={<LabShell />}>
          {RCPS_ENABLED && <Route path="/rcps/*" element={<EnterpriseOnly feature="금융상품 평가"><Suspense fallback={null}><RcpsPage /></Suspense></EnterpriseOnly>} />}
          <Route path="/buffett" element={<BuffettPage />} />
          <Route path="/peer/*" element={<PeerPage />} />
          {RELATIVE_ENABLED && <Route path="/peer/relative" element={<Suspense fallback={null}><RelativePage /></Suspense>} />}
          <Route path="/market" element={<MarketPage />} />
          {REPORT_ENABLED && <Route path="/report" element={<ReportPage />} />}
          {RE_ENABLED && <Route path="/re" element={<Suspense fallback={null}><RealEstatePage /></Suspense>} />}
        </Route>
        {RE_ENABLED && <Route path="/re/report/:id" element={<Suspense fallback={null}><RealEstateReportTab /></Suspense>} />}
        <Route path="/admin/*" element={<AdminPage />} />
        <Route path="*" element={<ChatPage />} />
      </Routes>
      {!user && <LoginOverlay />}
    </BrowserRouter>
  );
}
